import { Injectable } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs";
import { environment } from "src/environments/environment";

declare let gtag: Function;

@Injectable({
    providedIn: 'root'
})
export class GoogleAnalyticsService {
    constructor(private router: Router) {
        this.init();
    }

    private init() {
        this.router.events.pipe(
            filter((event): event is NavigationEnd => event instanceof NavigationEnd)
        ).subscribe((event: NavigationEnd) => {
            this.sendPageView(event.urlAfterRedirects);
        });

        gtag('js', new Date());
        gtag('config', environment.gaMeasurementId);
    }

    public sendPageView(url: string) {
        gtag('config', environment.gaMeasurementId, {
            'page_path': url
        });
    }

    public sendEvent(
        eventName: string, params: any = {}
    ): void {
        gtag('event', eventName, params);
    }
}